import DefaultSummary from '@kitconcept/volto-light-theme/components/Summary/DefaultSummary';
import config from '@plone/volto/registry';
import { FormattedMessage } from 'react-intl';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import FormattedDate from '@plone/volto/components/theme/FormattedDate/FormattedDate';

const CustomNewsListingItemTemplate = ({ item, isEditMode }) => {
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <>
      <div className="listing-body">
        <div className="item-metadata">
          <span className="item-category">
            {item.Date ? (
              <FormattedDate
                date={item.Date}
                format={{
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                }}
              />
            ) : null}
            {/* {item.Date ? (
              <>
                <FormattedMessage
                  id="listing.news_item_from"
                  defaultMessage="News Item from {date}"
                  values={{
                    date: (
                      <FormattedDate
                        date={item.Date}
                        format={{
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                        }}
                      />
                    ),
                  }}
                />
              </>
            ) : (
              <FormattedMessage
                id="listing.news_item"
                defaultMessage="News Item"
              />
            )} */}
          </span>
          {/* {item?.Subject?.map((tag, index) => (
            <span className="saw-tag" key={index}>
              {tag}
            </span>
          ))} */}
        </div>
        <DefaultSummary
          item={item}
          HeadingTag="h3"
          hide_description={
            !item.Description ||
            (item.Description && item.Description.trim() === '')
          }
        />
        {item?.preview_text && (
          <p className="listing-text">{item.preview_text}</p>
        )}
        <ConditionalLink
          item={item}
          condition={!isEditMode}
          className="listing-readmore"
        >
          <FormattedMessage id="listing.readmore.more" defaultMessage="Mehr" />
        </ConditionalLink>
      </div>
      {item?.image_field && (
        <Image
          item={item}
          image_field={item.image_field}
          width="265"
          alt="Teaserbild einer Nachricht"
        />
      )}
      {/* <Component componentName="PreviewImage" item={item} width="230" alt="alternativeText" showDefault={false} /> */}
    </>
  );
};

export default CustomNewsListingItemTemplate;
